/* eslint-disable no-unused-vars */
import {
  Box,
  Card,
  CardHeader,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  TablePagination,
  TextField,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import HelmetSeo from '../components/HelmetSeo';
import appConfig from '../config';
import { filterUsers } from '../store/actions/users.action';
import UserListTable from '../components/users/UserListTable';

export default function Users() {
  const dispatch = useDispatch();
  const { userListStatus } = useSelector((state) => state.users);
  const { roles, userStatuses } = useSelector((state) => state.app);

  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [filter, setFilter] = useState({
    page: 1,
    pageSize: appConfig.pagination.pageSize,
    roleId: null,
    statusId: null,
    gender: null,
  });

  const fetchUsers = async (payload) => {
    try {
      const response = await dispatch(filterUsers(payload)).unwrap();

      if (response.pagination) {
        setTotalCount(response.pagination.total);
        setTotalPages(response.pagination.totalPages);
      }

      setUsers(response.data);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const onPageChange = (event, newPage) => {
    const newFilter = { ...filter, page: newPage };
    setFilter(newFilter);
    fetchUsers(newFilter);
    console.log('Page: ', newPage);
  };

  const onRowsPerPageChange = (event) => {
    const limit = event.target.value;

    const newFilter = { ...filter, pageSize: limit };
    setFilter(newFilter);
    fetchUsers(newFilter);
  };

  const handleRoleChange = (event) => {
    const roleId = event.target.value;
    const newFilter = { ...filter, roleId };
    setFilter(newFilter);
    fetchUsers(newFilter);
  };

  const handleStatusChange = (event) => {
    const statusId = event.target.value;
    const newFilter = { ...filter, statusId };
    setFilter(newFilter);
    fetchUsers(newFilter);
  };

  useEffect(() => {
    fetchUsers(filter);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <>
      <HelmetSeo title="Users | Rewot Ciro" />

      <Box sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
      }}
      >
        <Card>
          <CardHeader title="Users" />
          <Divider />

          <Grid
            container
            spacing={1}
            sx={{ mt: 2, mb: 2 }}
          >
            <Grid item xs={12}>
              <Stack direction="row" spacing={3} sx={{ height: 56, m: 2 }}>
                <TextField
                  select
                  label="Select Status"
                  onChange={(e) => handleStatusChange(e)}
                  sx={{ minWidth: 250 }}
                >
                  <MenuItem value="">
                    <em>All</em>
                  </MenuItem>

                  {userStatuses.map((item) => (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  select
                  label="Select Role"
                  onChange={(e) => handleRoleChange(e)}
                  sx={{ minWidth: 250 }}
                >
                  <MenuItem value="">
                    <em>All</em>
                  </MenuItem>

                  {roles.map((item) => (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>

              </Stack>
            </Grid>
          </Grid>

          <Divider />

          <UserListTable loading={userListStatus === 'loading'} data={users} />

          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="flex-end"
            sx={{ mt: 4, mb: 5 }}
          >

            {/* <TablePagination
              component="div"
              count={totalCount}
              page={filter.page}
              onPageChange={onPageChange}
              rowsPerPage={filter.pageSize}
              onRowsPerPageChange={onRowsPerPageChange}
            /> */}

            <Pagination
              count={totalPages}
              color="primary"
              defaultPage={1}
              showFirstButton
              showLastButton
              onChange={onPageChange}
            />

          </Grid>
        </Card>
      </Box>
    </>
  );
}
